export default __webpack_public_path__ + "static/media/chicken.e5dcdb50.png";